import { createWebAudioCacheStore } from './audio-cache-store';
import { createWebTokenStore } from './token-store';
import type { PlatformConfig, WebPlatform } from '../types';

export function createWebPlatform(config: PlatformConfig): WebPlatform {
  return {
    tokenStore: createWebTokenStore(),
    audioCache: createWebAudioCacheStore(),
    config,
  };
}

export { createWebTokenStore } from './token-store';
export { createWebAudioCacheStore } from './audio-cache-store';
